import { Injectable } from '@angular/core';
import { BaseFormService } from '../BaseFormService';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../utility.service';

@Injectable({
	providedIn: 'root',
})
export class OtherTuitionReimbursementService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}forms/clients/$$clientId$$/other-tuition-reimbursement`, httpClient, utilityService);
	}

	getFormsForClient(clientId: string): Observable<any[]> {
		return this.httpClient.get<any[]>(`${this.getUrl(clientId)}/GetPreApprovalByClient`).pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}

	getTuitionReimbursementByEmployeeId(clientId: string, id: string, all: boolean): Observable<any[]> {
		return this.httpClient.get<any[]>(`${this.getUrl(clientId)}/${id}/employee-reimbursement-form?all=${all}`).pipe();
	}
}
